import { ApplicationData } from "../ApplicationData";


export class ChildSelectionList {
  constructor(children, locationConfiguration, displayHint = false) {
    this.children = children;
    this.locationConfiguration = locationConfiguration;
    this.id = `csl_${ChildSelectionList.getSequenceId()}`;
    this.displayHint = displayHint;
  }

  getListItem(child, selected = false) {
    const liStyle = "display: flex; align-items: center; margin: 8px 0;";
    const checkboxStyle = "margin-right: 8px;";
    // id as childId, ${id} gets replaced with com.tlcdelivers.ls2pac:ls2pac:war:5.7.4.0-SNAPSHOT at build time
    const { id: childId, firstName, lastName } = child;
    const checked = selected ? "checked" : "";
    const checkboxId = `${this.id}_${childId}`;
    const displayName = `${firstName} ${lastName}`;
    return `
        <li style="${liStyle}">
          <input id="${checkboxId}" type="checkbox" style="${checkboxStyle}" class="child-checkbox" value="${childId}" ${checked} />
          <label for="${checkboxId}">${displayName}</label>
        </li>
    `;
  }

  getList(children, selections = [], heading = "", hint = "") {
    if (children.length === 0) {
      return "";
    }

    // move when CSS module support is added
    const listStyle = "list-style: none;";
    const headingContent = heading ? `<h3 style="margin: 16px 0 12px">${heading}</h3>` : "";
    const hintContent = hint ? `<p style="padding: 0; margin: 16px 0;">${hint}</p>` : "";
    return `
      ${headingContent}
      ${hintContent}
      <ul style="${listStyle}" class="children">
        ${children
          .map((child) => {
            return this.getListItem(child, selections.includes(child.id));
          })
          .join("")}
      </ul>
    `;
  }

  getHeading(libraryName, tokenWithLibraryName, noLibraryNameDefaultToken) {
    return !libraryName || libraryName.trim().length === 0
      ? noLibraryNameDefaultToken
      : tokenWithLibraryName.replace("%LIBRARY_NAME%", libraryName);
  }

  getHTML(selections = []) {
    const { language } = ApplicationData;
    const { filterBranches, libraryName } = this.locationConfiguration;
    const configLocationIds = filterBranches.map((fb) => {
      return parseInt(fb.identifier, 10);
    });

    if (configLocationIds.length === 0) {
      return `
        <div id="${this.id}">
          ${this.getList(this.children, selections)}
        </div>
      `;
    }

    const childrenAtSchool = this.children.filter(
      (child) => configLocationIds.indexOf(child.issuingLocation) !== -1
    );
    const childrenNotAtSchool = this.children.filter(
      (child) => configLocationIds.indexOf(child.issuingLocation) === -1
    );
    const childrenAtSchoolHeading = this.getHeading(
      libraryName,
      language.studentsAtLibraryName,
      language.studentsAtThisSchool
    );
    const childrenNotAtSchoolHeading = this.getHeading(
      libraryName,
      language.studentsNotAtLibraryName,
      language.studentsNotAtThisSchool
    );

    const childrenAtSchoolContent = this.getList(
      childrenAtSchool,
      selections,
      childrenAtSchoolHeading
    );
    const childrenNotAtSchoolContent = this.getList(
      childrenNotAtSchool,
      selections,
      childrenNotAtSchoolHeading,
      this.displayHint ? language.studentsNotAtHint : ""
    );

    return `
      <div id="${this.id}">
        ${childrenAtSchoolContent}
        ${childrenNotAtSchoolContent}
      </div>
    `;
  }

  getSelections() {
    const childCheckboxes = Array.from(
      document.querySelectorAll(`#${this.id} .child-checkbox`)
    );
    return childCheckboxes
      .filter((childCheckbox) => childCheckbox.checked)
      .map((childCheckbox) => parseInt(childCheckbox.value, 10));
  }

  render(targetSelector, selections = []) {
    const target = document.querySelector(targetSelector);

    if (target) {
      target.insertAdjacentHTML("beforeend", this.getHTML(selections));
    }
  }

  destroy() {
    const childList = document.querySelector(`#${this.id}`);
    if (childList) {
      childList.remove();
    }
  }

  focus() {
    const firstChildCheckbox = document.querySelector(
      `#${this.id} .child-checkbox`
    );
    if (firstChildCheckbox) {
      firstChildCheckbox.focus();
    }
  }

  // ES6 transpilation of 'Public class fields' is not yet implemented by closure compiler. Using a static getter
  static getSequenceId() {
    if (!ChildSelectionList.sequenceId) {
      ChildSelectionList.sequenceId = 0;
    }
    return ChildSelectionList.sequenceId++;
  }
}

